import * as React from "react";
import { useLocation } from "react-router-dom";
import { OpportunitySearchQueryState } from "@skv/state";

import * as H from "history";

interface ReferrerState {
  searchQuery?: Partial<OpportunitySearchQueryState>;
  searchType?: "opp" | "org";
  children?: string;
}

export const useReferrer = (): H.LocationDescriptorObject<
  ReferrerState
> | null => {
  const location = useLocation<{
    referrer?: H.LocationDescriptorObject<ReferrerState>;
  }>();

  const [
    referrer,
    setReferrer,
  ] = React.useState<null | H.LocationDescriptorObject<ReferrerState>>(null);

  React.useEffect(() => {
    if (location.state?.referrer) {
      setReferrer(location.state.referrer);
    }
  }, [location]);

  return referrer;
};
